import { TAPIState } from './states.hook';

export const mockedStatesResponse: TAPIState[] = [
  {
    "key": "AK",
    "state": "Alaska"
  },
  {
    "key": "AL",
    "state": "Alabama"
  },
  {
    "key": "AR",
    "state": "Arkansas"
  },
];
